import { createApi } from '@stilingue/st-auth-utils';
import { error401Handler } from '@/utils/error';
import Service from './Service';

const gateway = process.env.VUE_APP_SERVICES_PROXY_URL || '';

const afterParser = (response) => {
  return response.data;
};

class ProprietaryMetricsService extends Service {
  constructor(gateway) {
    const api = createApi('/proprietary-metrics', gateway, {
      authNotFound: () => true,
      error401Handler,
    });
    super(api, { afterParser });
  }

  engagementMatrixPosts(params = {}) {
    return this.find({
      ...params,
      url: '/engagement-matrix/posts',
    });
  }

  engagementMatrixTags(params = {}) {
    return this.find({
      ...params,
      url: '/engagement-matrix/tags',
    });
  }
}

export default new ProprietaryMetricsService(gateway);
